var __defProp = Object.defineProperty;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {enumerable: true, configurable: true, writable: true, value}) : obj[key] = value;
var __assign = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
export default class AttributeHandler {
  constructor({attrGroup, attributeSelector}) {
    this.groups = {};
    this.canAdd = false;
    this.attrGroup = attrGroup;
    this.selector = attributeSelector;
    this.set();
  }
  set() {
    let groupArry = this.attrGroup;
    groupArry = groupArry.split(",");
    groupArry = groupArry.map((id) => ({
      id,
      visible: false,
      touched: false
    }));
    const groupObj = {};
    for (let group in groupArry) {
      groupObj[groupArry[group].id] = groupArry[group];
    }
    return this.groups = groupObj;
  }
  touchGroup(id) {
    this.groups[id].touched = true;
  }
  isGroupTouched(id) {
    return this.groups[id].touched;
  }
  isGroupVisible(id) {
    return this.groups[id].visible;
  }
  setGroupVisible(id) {
    this.groups[id].visible = true;
  }
  setGroupHidden(id) {
    this.groups[id].visible = false;
  }
  setVisibleGroups() {
    let groups = __assign({}, this.groups);
    Object.keys(groups).forEach((id) => {
      if (id) {
        const selector = this.selector.replace("{id}", id);
        const $el = $(selector);
        if ($el.length > 0) {
          this.setGroupVisible(id);
        } else {
          this.setGroupHidden(id);
        }
      }
    });
  }
  update() {
    this.setVisibleGroups();
    this.checkIfCanBeAddedToCart();
  }
  checkIfCanBeAddedToCart() {
    let groups = __assign({}, this.groups);
    groups = Object.values(groups);
    let visibleCount = 0;
    let touchedVisibleCount = 0;
    groups.forEach((el) => {
      el.visible && ++visibleCount;
      el.touched && el.visible && ++touchedVisibleCount;
    });
    this.canAdd = touchedVisibleCount === visibleCount;
  }
  areAllVisibleTouched() {
    return this.canAdd;
  }
}
